export default __webpack_public_path__ + "static/media/start-date.a1175237.svg";